(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import * as T from "./types";
import * as DP from "../dataProvider";
import PromiseBox from "../../../utils/promiseBox";
const promises = new PromiseBox(["hsCodes"]);
export const setCountryCode = countryCode => ({
  type: T.SET_COUNTRY_CODE,
  payload: countryCode
});
export const fetchCountries = () => async dispatch => {
  dispatch({
    type: T.FETCH_COUNTRIES_PENDING
  }); // const { data } = await DP.fetchCountries();

  dispatch({
    type: T.FETCH_COUNTRIES_FULFILLED,
    payload: [{
      code: "bj",
      label: "Armenian"
    }]
  });
};
export const init = () => dispatch => {
  dispatch(fetchCountries());
};
export const setSearchString = searchString => ({
  type: T.SET_SEARCH_STRING,
  payload: searchString
});
export const fetchHistory = () => async dispatch => {
  dispatch({
    type: T.FETCH_HISTORY_PENDING
  });

  try {
    // const { data } = await DP.fetchHistory();
    dispatch({
      type: T.FETCH_HISTORY_FULFILLED,
      payload: []
    });
  } catch (e) {
    dispatch({
      type: T.FETCH_HISTORY_REJECTED
    });
  }
};
export const fetchHsCodes = _ref => {
  let {
    searchString,
    countryCode,
    onShowError
  } = _ref;
  return async dispatch => {
    dispatch({
      type: T.FETCH_HS_CODES_PENDING
    });
    promises.cancelPromise("hsCodes");

    try {
      promises.hsCodes = DP.fetchHsCodes({
        searchString,
        countryCode
      });
      const {
        data
      } = await promises.hsCodes;

      if (data) {
        dispatch({
          type: T.FETCH_HS_CODES_FULFILLED,
          payload: data
        });
      }
    } catch (e) {
      if (!(e !== null && e !== void 0 && e.isCancelled)) {
        dispatch({
          type: T.FETCH_HS_CODES_REJECTED
        });

        if (onShowError) {
          onShowError(e);
        }
      }
    }
  };
};
export const fetchHsCodeDetails = _ref2 => {
  let {
    hsCode,
    countryCode
  } = _ref2;
  return async dispatch => {
    try {
      const {
        data
      } = await DP.fetchHsCodeDetails({
        hsCode,
        countryCode
      });
      dispatch({
        type: T.FETCH_HS_CODE_DETAILS_FULFILLED,
        payload: data,
        hsCode,
        countryCode
      });
    } catch (e) {
      dispatch({
        type: T.FETCH_HS_CODE_DETAILS_REJECTED,
        hsCode,
        countryCode
      });
    }
  };
};
export const fetchExplanatoryNotes = _ref3 => {
  let {
    hsCode,
    language
  } = _ref3;
  return async dispatch => {
    try {
      dispatch({
        type: T.FETCH_EXPLANATORY_NOTES_PENDING
      });
      const {
        data
      } = await DP.fetchExplanatoryNotes({
        hsCode,
        language
      });
      dispatch({
        type: T.FETCH_EXPLANATORY_NOTES_FULFILLED,
        payload: data
      });
    } catch (e) {
      dispatch({
        type: T.FETCH_EXPLANATORY_NOTES_REJECTED
      });
    }
  };
};
export const clearExplanatoryNotes = () => ({
  type: T.CLEAR_EXPLANATORY_NOTES
});
export const clearHsCodeDetails = () => ({
  type: T.CLEAR_HS_CODE_DETAILS
});
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(promises, "promises", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/actions.js");
  reactHotLoader.register(setCountryCode, "setCountryCode", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/actions.js");
  reactHotLoader.register(fetchCountries, "fetchCountries", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/actions.js");
  reactHotLoader.register(init, "init", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/actions.js");
  reactHotLoader.register(setSearchString, "setSearchString", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/actions.js");
  reactHotLoader.register(fetchHistory, "fetchHistory", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/actions.js");
  reactHotLoader.register(fetchHsCodes, "fetchHsCodes", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/actions.js");
  reactHotLoader.register(fetchHsCodeDetails, "fetchHsCodeDetails", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/actions.js");
  reactHotLoader.register(fetchExplanatoryNotes, "fetchExplanatoryNotes", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/actions.js");
  reactHotLoader.register(clearExplanatoryNotes, "clearExplanatoryNotes", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/actions.js");
  reactHotLoader.register(clearHsCodeDetails, "clearHsCodeDetails", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/actions.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();